var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TerittoryManagement',{attrs:{"filter":_vm.territoryManagementFilter,"options":_vm.options,"rangeOption":_vm.rangeOption,"data":_vm.data,"typeMap":'User Dealer',"trendSales":true},on:{"loadAPI":_vm.loadAPI}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }